import { create } from 'zustand';

/** The conversation open when history locked, published by the history lock once the same
 *  account is confirmed and its history reopened; thread persistence goes back to it. */
export const useReturnThread = create<{ threadId: string | null }>(() => ({ threadId: null }));
